import { useDocumentTitle } from 'usehooks-ts'

import useCurrentOrganization from './useCurrentOrganization'

export function useTitle(title: string) {
  const organization = useCurrentOrganization()
  useDocumentTitle(`${title} - ${organization.name}`)
}
